<template>
  <div class="imprint">
    <!--HEADER-->
    <header class="header--small"></header>
    <!-- SECTION-->
    <section class="section my-5">
      <mdb-container>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <h2 class="section__heading">Impressum</h2>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-4 justify-content-center">
          <mdb-col md="10">
            <p>Institut für Sensorikforschung und Innovationsberatung GmbH</p>
            <p class="mt-4">Ascherberg 2</p>
            <p>37124 Rosdorf / Göttingen</p>
            <p>Telefon: +49 551 499 74 0</p>
            <p>Telefax: +49 551 499 74 20</p>
            <p>Email: mail@isi-insights.com</p>
            <p class="mt-4">
              Vertretungsberechtigte Geschäftsführer: Joachim Haag, Robert
              Möslein
            </p>
            <p>Registergericht: Amtsgericht Göttingen</p>
            <p>Registernummer: HR 2623</p>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a
              Umsatzsteuergesetz: DE 186404739
            </p>
            <p class="mt-4">
              Haftungshinweis: Trotz sorgfältiger inhaltlicher Kontrolle
              übernehmen wir keine Haftung für die Inhalte externer Links. Für
              den Inhalt der verlinkten Seiten sind ausschließlich deren
              Betreiber verantwortlich.
            </p>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>
    <!-- ./SECTION-->
    <app-footer />
  </div>
</template>

<script>
import AppFooter from "../components/Footer.vue";
import { mdbSmooth } from "mdbvue";
export default {
  components: { AppFooter },
  directives: {
    mdbSmooth,
  },
  name: "Imprint",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Legal Notice",
    // all titles will be injected into this template
    titleTemplate: "%s | isi Test Studio Finder",
  },
};
</script>

<style lang="scss">
@import "~@/styles/parts/_section.scss";
.imprint p {
  margin: 0.5rem;
  font-size: 1.1rem;
  font-family: "klavika";
}
</style>